define([
    "./driverMapModule",
    "./driverMapRouter",
    "./DriverMapController"
], function () {
});